/**
 * VIP会员专享福利
 */
import index from './index.vue'

export default index
